import { defaultIconProps, IconProps } from './IconProps';

export const IconCopyLink: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M8.47179 12.2427L7.52898 13.1855C6.22723 14.4872 4.11668 14.4872 2.81493 13.1855C1.51319 11.8837 1.51319 9.77317 2.81493 8.47142L3.75774 7.52861M12.243 8.47142L13.1858 7.52861C14.4876 6.22687 14.4876 4.11632 13.1858 2.81457C11.8841 1.51282 9.77354 1.51282 8.47179 2.81457L7.52898 3.75738M5.66705 10.3333L10.3337 5.66667"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconCopyLink.defaultProps = defaultIconProps;
